module.exports = __webpack_public_path__ + "static/img/img04.54297f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv002/img04.jpg
// module id = F3C9
// module chunks = 0